import { Button } from '@/components/ui/button';
import { InfoTypeDisplay, NodeBody, NodeContainer, NodeErrorIcon, NodeHeader, NodePrompts } from '@/nodes/NodeUI';
import type { AddressLookupNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import { type FC, useContext } from 'react';
import { FlowParamsContext } from '../app/FlowInitializer';

const AddressLookupNode: FC<NodeProps<AddressLookupNodeType>> = ({ id, selected, data }) => {
    const paths = outgoingHandles['address-lookup'](id as GuideNodeId, data);
    const { spaceId } = useContext(FlowParamsContext);

    return (
        <NodeContainer>
            <NodeErrorIcon id={id} />
            <NodeHeader id={id} type={data.type} title={data.pageTitle} />
            <NodeBody selected={selected}>
                <NodePrompts prompts={data.prompts} />
                {data.infoTypeId && (
                    <div className="py-1 px-3 gap-1 flex flex-row items-center justify-center">
                        <div className="text-xs text-primary">{data.dataKey} =</div>
                        <div className="bg-white border-1 border-black flex-1 py-1 px-4 gap-1 flex flex-row items-center justify-center">
                            <div className="text-xs text-primary">Address:</div>
                            <InfoTypeDisplay spaceId={spaceId} typeId={data.infoTypeId} />
                        </div>
                    </div>
                )}
                <div className="my-2">
                    <Button size="sm">{data.buttonLabel || 'Look Up'}</Button>
                </div>
            </NodeBody>

            <Handle type="target" position={Position.Left} />

            <div className="absolute right-[-15px] top-[33%]">
                <div className="text-[6pt] py-0.5 px-2 border-1 border-black bg-green-100 rounded-sm mr-[1px]">
                    NEXT
                </div>
                <Handle type="source" id={paths.next} position={Position.Right} />
            </div>

            <div className="absolute right-[-15px] top-[66%]">
                <div className="text-[6pt] py-0.5 px-2 border-1 border-black bg-red-100 rounded-sm mr-[1px]">FAIL</div>
                <Handle type="source" id={paths.failure} position={Position.Right} />
            </div>
        </NodeContainer>
    );
};

export default AddressLookupNode;
